import { Component, viewChild } from '@angular/core';
import {
  PopoverComponent,
  Button,
  SimplePopoverLayout,
  SimpleDialog,
  SimpleDialogLayout,
} from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';
import { environment } from '../../../../../environments/environment';
import { YoutubeEmbed } from '../../../../shared/components/youtube-embed/youtube-embed';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-tutorial-supplier-contracts-popover',
  imports: [
    PopoverComponent,
    NgIcon,
    Button,
    SimplePopoverLayout,
    SimpleDialog,
    SimpleDialogLayout,
    FeatureEnabledDirective,
    YoutubeEmbed,
    TranslocoPipe,
  ],
  templateUrl: './tutorial-supplier-contracts-popover.html',
})
export class TutorialSupplierContractsPopover {
  private tutorialPopover = viewChild<PopoverComponent>('tutorialPopover');

  protected embedVideoUrl = environment.tutorialVideoEmbedLinks.supplierContracts;

  showPopover() {
    this.tutorialPopover()?.show();
  }
}
